import React, { useState } from 'react';
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Main from '../components/Main'
import Midjourney from '../../Midjanouney/components/Midjourney'
import Button from '@mui/material/Button';
 

function Home() {
  const [showMain, setShowMain] = useState(true);

  const handleToggle = () => {
    setShowMain((prevShowMain) => !prevShowMain);
  };
  return (
    <div>
        <Navbar/>
        <Footer/>
        <Button variant="text" onClick={handleToggle}>
        {showMain ? 'Open AI' : 'Mid-journey'}
      </Button>
      {showMain ? <Main /> : <Midjourney />}
    </div>
  )
}

export default Home